<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div *ngIf="definition" class="f-column f-justify-start f-align-stretch" style="flex: 1 1 0">

    <ng-container *ngIf="dataSource?.hasHtml$ | async; then htmlTemplate; else dataTemplate"></ng-container>

</div>

<ng-template #dataTemplate>
    <div class="table-container" fxFlex fxFlexAlign="stretch">
            <table mat-table [dataSource]="dataSource">
                <ng-container *ngIf="definition.totalFields">
                    <td mat-footer-cell *matFooterCellDef>Totals:</td>
                </ng-container>
                <ng-container *ngIf="definition.averageFields">
                    <td mat-footer-cell *matFooterCellDef>Averages:</td>
                </ng-container>

                <ng-container *ngFor="let field of definition.fields; let i = index" [matColumnDef]="field.name">
                    <th mat-header-cell *matHeaderCellDef>{{ field.display }}</th>
                    <td mat-cell *matCellDef="let row"
                        [style.max-width]="field.maxWidth || ''"
                        [style.min-width]="field.minWidth || ''"
                        [class.no-wrap]="!field.wrap">
                        <dash-gis-base-field [fieldDefinition]="field" [rowData]="row"
                                       [tableEditActive]="false"></dash-gis-base-field>
                    </td>
                </ng-container>

                <!-- totals -->
                <ng-container *ngFor="let fieldName of columnsToDisplay; let i = index"
                              [matColumnDef]="'total_' + fieldName">
                    <ng-container *ngIf="definition.totalFields">
                        <ng-container [ngSwitch]="getTotalsCellDisplay(fieldName, i)">
                            <ng-container *ngSwitchCase="'label'">
                                <td mat-footer-cell *matFooterCellDef>Totals:</td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'value'">
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalsValue$(fieldName) | async | number: '1.2' }}
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!definition.enableZoom && i === 0">
                            <td mat-footer-cell *matFooterCellDef>Totals:</td>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <!-- averages -->
                <ng-container *ngFor="let fieldName of columnsToDisplay; let i = index"
                              [matColumnDef]="'average_' + fieldName">
                    <ng-container *ngIf="definition.averageFields">
                        <ng-container [ngSwitch]="getAveragesCellDisplay(fieldName, i)">
                            <ng-container *ngSwitchCase="'label'">
                                <td mat-footer-cell *matFooterCellDef>Averages:</td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'value'">
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getAveragesValue$(fieldName) | async | number: '1.2' }}
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!definition.enableZoom && i === 0">
                            <td mat-footer-cell *matFooterCellDef>Averages:</td>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let rowData; columns: columnsToDisplay"></tr>
                <ng-container *ngIf="definition.totalFields">
                    <tr mat-footer-row *matFooterRowDef="totalsColumnsToDisplay"></tr>
                </ng-container>
                <ng-container *ngIf="definition.averageFields">
                    <tr mat-footer-row *matFooterRowDef="averagesColumnsToDisplay"></tr>
                </ng-container>
            </table>
        </div>
</ng-template>

<ng-template #htmlTemplate>
    <div class="selectable-text f-column f-justify-space-between f-align-start f-self-stretch"
         style="flex: 1 1 auto;"
         [innerHTML]="dataSource?.reportHtml"></div>
</ng-template>

